import React , {useEffect} from 'react';
import useModel from '../admin/common/useModel';
import Model from '../admin/common/stationPopup';
const BuyAdds =() =>{

  const {isShowing, toggle} = useModel();

  //This method is use for open popup.
  const openPopup =() =>{
    document.body.classList.add('hide_overflow');
    toggle();
  }

    return(
        <div className="buy_ads_left">
           <Model
        isShowing={isShowing}
        hide={toggle}
      />
        <h2>BUY ADS ON BIGFM</h2>
        <span>YOUR SELF SERVICE AD PORTAL</span>
        <div className="border_line" />
        <div className="buy_ads_count_wrapper">
          <div className="stations_counts_wrapper">
            <div className="counter" onClick={openPopup}>58</div>
            <div className="count_desc">
              <span>STATIONS</span>
              <span>Indian's Strongest Network</span>
            </div>
          </div>
          <div className="states_counts_wrapper">
            <div className="counter">24</div>
            <div className="count_desc">
              <span>STATES</span>
              <span>Out of 29 States</span>
            </div>
          </div>
          <div className="languages_counts_wrapper">
            <div className="counter">18</div>
            <div className="count_desc">
              <span>Languages</span>
              <span>Covered</span>
            </div>
          </div>                  
        </div>
        {/* <div className="website_btn">
          <a href= "https://www.bigfmindia.com/" target= "__blank">BIGFM WEBSITE</a>
        </div> */}
        </div>
    );
}

export default BuyAdds;


// WEBPACK FOOTER //
// ./web/components/home/BuyAdds.js